import { Component, OnInit } from '@angular/core';
import { timer } from "rxjs";

@Component({
    selector: 'app-dialogs-page',
    templateUrl: './dialogs-page.component.html',
    styleUrls: ['./dialogs-page.component.scss']
})
export class DialogsPageComponent implements OnInit {

    public is3sToastVisible: boolean = false;
    public is5sToastVisible: boolean = false;
    public is7sToastVisible: boolean = false;

    public exampleCode: string =
`<say-toast [toggle3s]="is3sToastVisible" (toggleOff)="is3sToastVisible = false">
    <p>This is a 3 second toast message</p>
</say-toast>`;

    constructor() {
    }

    ngOnInit() {
    }
}
